
<app-main-header header *transloco="let t">{{ t('forgot-password') }}</app-main-header>
<app-change-password [formGroup]="formGroup" *transloco="let t">
  <app-epson-logo [animate]="loading" image></app-epson-logo>
  <app-header divider>
    {{ t('create-new-password') }}
  </app-header>
  <app-paragraph text>
    {{ t('recover-password-informative-text') }}
  </app-paragraph>
  <app-input id="forgot-password-page-email-input"
             input
             [control]="emailControl"
             required
             [label]="t('email-address')"></app-input>
  <app-label isError>{{ errorMessage }}</app-label>
  <app-recaptcha *ngIf="recaptchaEnabled"
    id="recaptcha-login-forgot"
    [formGroup]="formGroup"
    abstractFormControlName="recaptcha"
    recaptcha
    #captchaRef>
  </app-recaptcha>
  <app-primary-button id="forgot-password-page-recover-password-click"
                      button
                      (clickAction)="forgotPassword()"
                      [disabled]="isForgotPasswordDisabled()">
    {{ t('recover-password') }}
  </app-primary-button>
  <app-primary-button id="forgot-password-page-back-click"
                      button
                      (clickAction)="goBack()">
    {{ t('back')}}
  </app-primary-button>
</app-change-password>
